<template>
  <div class="buy-panel">
    <transition v-if="buyPanelConfiguration.wishlist_notification" name="fade">
      <tmall-wishlist-notification v-show="showTmallWishlistNotification" :favoriteSaved="tmallWishlistSaved"></tmall-wishlist-notification>
    </transition>
    <section>
      <div class="buy-panel-backdrop" @click="hideBuyPanel"></div>
      <div :class="[
          'buy-panel-wrapper',
          { 'is-tmall': $store.getters['utils/tmallEnabled'] }
        ]"
      >

        <div
        :class="isCloseButtonAsText ? 'buy-panel-wrapper-close-text' : 'buy-panel-wrapper-close'" @click="hideBuyPanel">
          <span v-if="isCloseButtonAsText">{{ translations.buyPanelTmallBack }}</span>
          <span v-else class="buy-panel-wrapper-close-icon icon-close"></span>
        </div>
        <div class="buy-panel-wrapper-buymenu">
          <div class="buy-panel-wrapper-buymenu-overlay">
            <product-image v-if="!configuration.enableSnapshotService" :isSpinnerPositionHigher="buyPanelConfiguration.spinner_position_higher" :recipeId="recipeId"></product-image>
            <div v-else class="buy-panel-product-image">
              <snapshot-image v-if="isVisible" :isSpinnerPositionHigher="buyPanelConfiguration.spinner_position_higher"></snapshot-image>
            </div>
            <product-info :isModelPriceLabelPositionCentered="buyPanelConfiguration.model_price_label_position_centered" :isFavoritesOnly="isFavoritesOnly" :checkUGC="checkUGC" :tmallIsUGCMS="tmallIsUGCMS"></product-info>
            <div :class="[
                'tile-selectors__options',
                {'reverse': configuration.size_selector_tiles.buyPanel && !disableQuantity}
              ]">
              <size-selection
                v-if="!configuration.size_selector_tiles.buyPanel || !configuration.quantity_selector_tiles.buyPanel"
                :isQuantityLabelHide="buyPanelConfiguration.quantity_label_hide"
                :isQuantitySelectHide="buyPanelConfiguration.quantity_select_hide"
                :isFavoritesOnly="isFavoritesOnly"
                :showSizeGuide="showSizeGuide"
                :buyPanelIsLoading="isLoading"
                :disableQuantity="disableQuantity"
                ref="buyPanelFormContainer"
              ></size-selection>
              <tiles-selection
                v-if="configuration.size_selector_tiles.buyPanel || configuration.quantity_selector_tiles.buyPanel"
                :showSizeTiles="configuration.size_selector_tiles.buyPanel"
                :showQuantityTiles="configuration.quantity_selector_tiles.buyPanel && !buyPanelConfiguration.quantity_select_hide"
                :buyPanelIsLoading="isLoading"
                customClass="tile-selectors buy-panel-size-selection"
                ref="buyPanelFormContainer"
              ></tiles-selection>
            </div>
          </div>
          <save-design v-if="isMyAddToCart && !disableShare" :isUGCApplied="checkUGC" :tmallIsUGCMS="tmallIsUGCMS" :onlyFavorites="isFavoritesOnly" :isWishlistButtonEnabled="buyPanelConfiguration.wishlist_button_enabled"></save-design>
          <add-to-cart v-if="(isMyAddToCart && !isFavoritesOnly && (!checkUGC || tmallIsUGCMS)) || !isMyAddToCart" :isMyAddToCart="isMyAddToCart" :disableShare="disableShare" :isAddToCartWideCta="buyPanelConfiguration.add_to_cart_wide_cta"></add-to-cart>
        </div>
      </div>
    </section>
    <size-guide-modal v-if="showSizeGuide"></size-guide-modal>
  </div>
</template>
<script>
import productImage from '@/components/BuyPanel/ProductImage';
import productInfo from '@/components/BuyPanel/ProductInfo';
import sizeSelection from '@/components/BuyPanel/SizeSelection';
import tilesSelection from '@/components/BuyPanel/TilesSelection';
import saveDesign from '@/components/BuyPanel/SaveDesign';
import addToCart from '@/components/BuyPanel/AddToCart';
import snapshotImage from '@/components/BuyPanel/SnapshotImage';
import sizeGuideModal from '@/components/BuyPanel/SizeGuideModal';
import tmallWishlistNotification from '@/components/Customizer/CustomizerHeader/TmallWishlistNotification';
import customsTools from '@/mixins/CustomsTools';
import { getLocale } from "@/data/regionInfo";


export default {
  name: "BuyPanel",
  components: {
    productImage,
    productInfo,
    sizeSelection,
    saveDesign,
    addToCart,
    sizeGuideModal,
    tmallWishlistNotification,
    tilesSelection,
    snapshotImage
  },
  data() {
    return {
      isVisible: false,
      isLoading: false,
      checkUGC: false,
      showTmallWishlistNotification: false,
      tmallWishlistSaved: false,
      tmallIsUGCMS: false,
      isFavoritesOnly: false
    };
  },
  mixins: [ customsTools ],
  computed: {
    translations(){
      return this.$store.state.translations.data;
    },
    configuration() {
      return this.$store.state.utils.configuration;
    },
    buyPanelConfiguration() {
      return this.$store.state.utils.configuration.vue_component_settings.buy_panel;
    },
    ugcSize() {
      return this.$store.state.buyPanel.ugcSize;
    },
    isUGCApplied() {
      return this.$store.state.buyPanel.isUGCApplied;
    },
    itemsToPurchase() {
      return this.$store.state.buyPanel.itemsToPurchase;
    },
    recipeId() {
      return this.$store.state.recipe.recipeId;
    },
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
    initRecipe() {
      return this.$store.state.recipe.initRecipe;
    },
    savedRecipe() {
      return this.$store.state.recipe.savedRecipe;
    },
    showSizeGuide() {
      const { utils } = this.$store.state;
      return utils && utils.pdm && !!utils.pdm.size_guide_url;
    },
    isCloseButtonAsText() {
      return this.$store.state.utils.configuration.vue_component_settings.buy_panel.close_button_as_text;
    },
    isMyAddToCart() {
      return this.$store.state.utils.caid === 'apac-zh-cn-tmall';
    },
    disableQuantity() {
      const disable = !!this.$store.state.swatches.palettes.find((item) => item.hide_quantity === 1) || this.configuration.hideQuantity === true;
      // Used to show/hide quantity dropdown select in SizeSelection
      return !disable && this.configuration.quantity_selector_tiles.buyPanel;
    },
     disableShare() {
      return !!(this.$store.getters['swatches/lockedPalettes'].length + this.$store.getters['swatches/uniqueSwatches'].length);
    },
    noEsiActive() {
      return this.$store.getters['utils/noEsiActive'];
    },
    vsfActive() {
      return this.$store.getters['utils/vsfActive'];
    },
    useEcomDataLayerFormat() {
      return this.$store.getters['utils/useEcomDataLayerFormat'];
    }
  },
  methods: {
    /**
     * @function setIsUGCApplied
     * This method set isUGCApplied variable rely on ugc object.
     */
    setIsUGCApplied() {
      this.$store.commit("buyPanel/SET_IS_UGC_APPLIED", false);

      const components = this.getComponentsUgc();
      // Iterate over ugc components
      if (components.length > 0) {
        components.forEach(componentName => {
          // Check for ugc as a swatch and pattern maker
          const component = this.recipe_v2.components[componentName];
          const UGCasSwatch = this.$ugc.isUGCFromSwatch(component.swatch_id);
          const hasPatternOrCustomCheckerboard = this.$ugc.isUGCCreatedByFeature(component, {
            includePatternMaker: true,
            includeCustomCheckerboard: true,
          });

          if (!UGCasSwatch && !hasPatternOrCustomCheckerboard) {
            this.$store.commit("buyPanel/SET_IS_UGC_APPLIED", true);
          }
        });
      }
    },
    /**
     * @function checkModeration
     * This method send a recipe to check its moderation status
     */
    checkModeration() {
      this.tmallIsUGCMS = false;
      return new Promise((resolve, reject) => {
        if(this.isUGCApplied && this.isMyAddToCart) {
          this.$store
            .dispatch("recipe/CHECK_MODERATION")
            .then(data => {
              if(data.status === "approved") {
                this.tmallIsUGCMS = true;
              }
              resolve();
            })
            .catch(err => {
              console.error("Error getting sku:", err);
              reject(err);
            });
        } else {
          resolve();
        }
      });
    },
    /**
     * @function getComponentUg
     * This method find all components with ugc object.
     */
    getComponentsUgc() {
      return this.$store.getters["utils/getComponentsUgc"]({ recipe: this.recipe_v2 });
    },
    /**
     * @function moveTopScroll
     * Position the buy panel to scroll at the top in add your touch carrousel
     */
    moveTopScroll(selector) {
      if (document.querySelector(selector) !== null) {
        // `.scrollTo()`` doesn't work on Edge browser, so the condition below handles Edge differently
        if (!navigator.userAgent.includes('Edge')) {
          window.scrollTo({ top: 0, behavior: 'smooth'});
        } else {
          document.body.scrollTop = 0;
        }
      }
    },
    /**
     * @function hideBuyPanel
     * Hide buy panel and set body class
     */
    hideBuyPanel() {
      this.isVisible = false;
      if(this.isMyAddToCart) {
        this.$eventBus.$emit("enable-add-to-cart-button", false);
      }

      this.vsfActive && this.$eventBus.$emit('customsBuyPanel', { visible: this.isVisible });

      if (this.useEcomDataLayerFormat) {
        this.$customizerDataLayer.logAnalyticsEvent({
          type: this.$customizerDataLayer.types.customizerBuyPanel,
          eventLabel: 'Close Modal'
        });
      }

      document.body.classList.remove("body-offcanvas", "open-buypanel");
      this.moveTopScroll(".custom-add-your-touch");
      this.$store.commit("recipe/SET_SAVED_RECIPE", this.$store.state.recipe.recipe_v2);
    },

    /**
     * @function showBuyPanel
     * This method show buy panel.
     */
    showBuyPanel(setDataLayer = false, isFavoritesOnly = false) {
      this.isVisible = true;
      this.isFavoritesOnly = isFavoritesOnly;
      this.checkUGC = this.$recipe.checkUGCByType({ customUGC: true });
      document.body.classList.add("body-offcanvas", "open-buypanel");

      this.$eventBus.$emit('buypanel-open');
      this.vsfActive && this.$eventBus.$emit('customsBuyPanel', { visible: this.isVisible });
      this.$store.dispatch("buyPanel/GET_PRICE", { recipe: this.recipe_v2 })
        .catch(err => console.error("showBuyPanel: Error getting price:", err));

      if (this.itemsToPurchase.length === 0) this.evaluateItemsToPurchase();
      if (JSON.stringify(this.recipe_v2) !== JSON.stringify(this.savedRecipe)) {
        this.setLoadingState(true);
        this.$store.dispatch("recipe/SAVE_RECIPE", {
          recipe: this.recipe_v2,
          requestParams: { locale: getLocale() }
        }).then(({ recipeId }) => {
          this.$store.commit("recipe/SET_SAVED_RECIPE", this.recipe_v2);
          const componentsWithUgc = this.$ugc && this.$ugc.getComponentsWithUgcApplied(false);
          if(componentsWithUgc && componentsWithUgc.length > 0) {
            this.$store.commit("buyPanel/SET_UGC_SIZE", this.recipe_v2.components[componentsWithUgc[0]].ugc.size);
          }
          this.storeNewRecipe(recipeId);
          return this.checkModeration();
        }).then(() => {
          this.setLoadingState(false);

          if (setDataLayer) {
            this.setDataLayer();
          }
        }).catch(err => {
          console.error("Error getting product image:", err);
          if (err === 'InvalidRecipeError') {
            this.hideBuyPanel();
          }
        });
      } else {
        this.storeNewRecipe(this.recipeId);

        if (setDataLayer) {
          this.setDataLayer();
        }
      }
    },
    storeNewRecipe(recipe_id) {
      if (!!Object.keys(this.$store.state.utils.audienceSizes).length && this.isUGCApplied) {
        this.$store.commit("buyPanel/STORE_A_RECIPE", recipe_id);
      }
      this.$nextTick(() => {
        this.$eventBus.$emit('recipe-saved', { recipe_id });
      })
    },
    setLoadingState(state) {
      this.isLoading = state;
      this.$eventBus.$emit("enable-add-to-cart-button", !state);
    },
    setDataLayer() {
      this.$nextTick(() => {
        const initComponents = this.initRecipe.components;
        const v2Components = this.recipe_v2.components;

        if (!initComponents || !v2Components) {
          console.error('setDataLayer BuyPanel error');
          return;
        }

        const lengthOrderedComponents = Object.keys(initComponents).length >= Object.keys(v2Components).length ?
          [ initComponents, v2Components ] : [ v2Components, initComponents ];

        const updatedComponents = Object.keys(lengthOrderedComponents[0]).filter(component =>
          JSON.stringify(lengthOrderedComponents[0][component]) !== JSON.stringify(lengthOrderedComponents[1][component])
        ).sort((a, b) => a.localeCompare(b)).join(',');

        this.checkUGC = this.$recipe.checkUGCByType({ customUGC: true });

        if (!this.useEcomDataLayerFormat) {
          dataLayer.push({
            'event': 'trackEvent',
            'recipeId': this.recipeId,
            'bundleId': this.$store.state.utils.pdm.partnumber,
            'name': this.$store.state.utils.pdm.product_name,
            'eventCategory': 'customs',
            'eventAction': 'buy cta',
            'eventLabel': updatedComponents
          });
        }
      });
    },
    /**
     * @function replaceSizesSelected
     * This method replace all the forms group when the ugc flow is done.
     * Set the ugcSize selected.
     */
    replaceSizesSelected() {
      this.$store.commit("buyPanel/RESET_STORED_RECIPES");
      this.$store.commit("buyPanel/RESET_ITEMS_TO_PURCHASE");
      if (!this.$ugc) return false;
      const componentsWithUgc = this.$ugc.getComponentsWithUgcApplied(false);
      const components = this.getComponentsUgc();
      if (
        componentsWithUgc.length > 0 &&
        components.length - componentsWithUgc.length == 1
      ) {
        this.$store.commit("buyPanel/SET_UGC_SIZE", this.recipe_v2.components[componentsWithUgc[0]].ugc.size);
        const componentsWithUgcAsSwatch = this.$ugc.getComponentsWithUgcApplied(
          true
        );
        this.recipe_v2.components[
          componentsWithUgcAsSwatch[0]
        ].ugc.size = this.ugcSize;
      } else if (components.length > 0) {
        const ugcSizeApplied = this.isUGCApplied ? this.$recipe.getCustomUGCSizeFromRecipe() : this.recipe_v2.components[components[0]].ugc.size;
        this.$store.commit("buyPanel/SET_UGC_SIZE", ugcSizeApplied);
      }
      if(this.ugcSize) this.$store.commit("buyPanel/REPLACE_SIZE_SELECTED", this.ugcSize);
    },
    /**
     * @function evaluateItemsToPurchase
     * This method verify forms group.
     */
    evaluateItemsToPurchase() {
      if (this.$recipe.isRecipeChanged()) {
        this.$store.commit("buyPanel/RESET_ITEMS_TO_PURCHASE");
        this.$store.commit("buyPanel/RESET_STORED_RECIPES");
      }
      this.setIsUGCApplied();
      if (this.isUGCApplied) {
        // Reset active index for reposition flow
        const libraryChecks = this.$store.getters['ugc/getComponentsByUGCSubgroupApplied']({ subgroupIdentifier: "library"});
        if (libraryChecks.length > 0) {
          this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", "imageLibrary");
        } else {
          this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", "ugc");
        }
        this.replaceSizesSelected();
      }
    },
    /**
     * @function evaluateItemsToPurchaseAndShow
     * Populates the SizeSelection component and shows the Buy Panel.
     */
    evaluateItemsToPurchaseAndShow() {
      this.evaluateItemsToPurchase();
      this.showBuyPanel(true);
    },
    handleTmallCTASaveDesign(isSaved) {
      if (isSaved === true) {
        this.tmallWishlistSaved = true;
      }
      this.showTmallWishlistNotification = true;
      setTimeout(() => this.showTmallWishlistNotification = false, 3000);
    }
  },
  created() {
    if(this.configuration.isMainApp) this.$endpoints.setEndpointEnv('customizer', false);

    this.$eventBus.$on('show-buy-panel', this.showBuyPanel);
    this.$eventBus.$on('hide-buy-panel', this.hideBuyPanel);
    this.$eventBus.$on('buyButtonClicked', this.evaluateItemsToPurchase);
    this.$eventBus.$on('tmall-resize-buypanel', this.evaluateItemsToPurchase);
    this.$eventBus.$on('tmall-wishlist-saved', this.handleTmallCTASaveDesign);
    this.$eventBus.$on('buyButtonClicked', this.evaluateItemsToPurchaseAndShow);
  },
  beforeDestroy() {
    this.$eventBus.$off('show-buy-panel', this.showBuyPanel);
    this.$eventBus.$off('hide-buy-panel', this.hideBuyPanel);
    this.$eventBus.$off('buyButtonClicked', this.evaluateItemsToPurchase);
    this.$eventBus.$off('tmall-resize-buypanel', this.evaluateItemsToPurchase);
    this.$eventBus.$off('tmall-save-design', this.handleTmallCTASaveDesign);
    this.$eventBus.$off('buyButtonClicked', this.evaluateItemsToPurchaseAndShow);
  }
};
</script>
<style lang="scss">
  .customs-tools {
    @import "~@/styles/_components/BuyPanel/BuyPanel.scss";
  }
</style>
